import { render } from "./Crm.vue?vue&type=template&id=44c267eb&lang=pug"
import script from "./Crm.vue?vue&type=script&lang=js"
export * from "./Crm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lauouts/Crm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44c267eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44c267eb', __exports__)) {
    api.reload('44c267eb', __exports__)
  }
  
  module.hot.accept("./Crm.vue?vue&type=template&id=44c267eb&lang=pug", () => {
    api.rerender('44c267eb', render)
  })

}


export default __exports__